import { useEffect, useState } from 'react';

// A new scope or explicit entry intent chooses a default. Editing a query does not.
export default function useSearchResultsSelection(scopeKey, initialTab, options) {
    const [selection, setSelection] = useState({ scopeKey, initialTab, value: initialTab });
    const requestedValue = selection.scopeKey === scopeKey && selection.initialTab === initialTab
        ? selection.value : initialTab;
    const selectedValue = options.some(option => option.value === requestedValue)
        ? requestedValue : options[0]?.value;
    useEffect(() => {
        setSelection(current => current.scopeKey === scopeKey && current.initialTab === initialTab && current.value === selectedValue
            ? current : { scopeKey, initialTab, value: selectedValue });
    }, [scopeKey, initialTab, selectedValue]);
    const onChange = value => setSelection({ scopeKey, initialTab, value });
    return { selectedValue, onChange };
}
